import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpParams } from "@angular/common/http";
import { GoodApiService } from "@app/services/good-api.service";
import { Good } from "@app/models/good.model";
import { GoodSpecificationsResponse, SupplyResponse } from "@app/ui_models/web-response";
import { PAGINATION_OPTIONS, tabHeader1 } from "@app/components/supplies/supplies.component";
import { Table, TableLazyLoadEvent } from "primeng/table";
import { SupplyController } from "@app/ui_controllers/supplyController";
import { DatePipe } from "@angular/common";
import { FilterService } from "@app/services/filter.service";
import { DataService } from "@app/services/data.service";
import { MedOptionType } from "@mk/med-ui";
import { ReserveController } from "@app/ui_controllers/reserveController";
import { tabHeaderReservesSpecifications } from "@app/components/reserves/reserves.component";
import { MoneyUtil } from "@app/utils/money.util";

@Component({
  templateUrl: "./availability.component.html",
  styleUrls: ["./availability.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AvailabilityComponent implements OnInit {

  constructor(private readonly reserveController: ReserveController,
              private route: ActivatedRoute,
              private router: Router,
              private supplyController: SupplyController,
              private goodsService: GoodApiService,
              public dataService: DataService,
              public filter: FilterService) {
  }

  @ViewChild("dt") dt: Table | undefined;
  good: Good  = {};
  goodId: string | null = "";
  loadingCounter = 0;
  tableBody:  SupplyResponse[] = [];
  // tabHeader: { label: string; key: string; date: boolean; filter: boolean; joinTable: string; }[] = tabHeaderAvailability;
  selectedPageNumber = 1;
  sortOrder: number | undefined | null = null;
  filterActive = true;
  filterField: string | string[] | null | undefined = "";
  tableState: TableLazyLoadEvent = {};
  rows = 0;
  totalRows = 0;
  pageSize = 10;
  showedOnPage = 10;
  tableBodySpecifications:  GoodSpecificationsResponse [] = [];
  selectedPageNumberSpecifications = 1;
  optionsModel = 1;
  pageSizeSpecifications = 10;
  totalRowsSpecifications = 0;
  hideGroup1 = false;
  hideGroup2 = false;
  tabHeaderSpecifications: { label: string; key: string; date: boolean; filter: boolean; joinTable: string; showChevron: boolean; chevronOpen: boolean; hideAbleColumn: boolean; }[] = tabHeaderReservesSpecifications;
  readonly paginationOptions: MedOptionType<number>[] = PAGINATION_OPTIONS;

  ngOnInit(): void {
    this.goodId = this.route.snapshot.paramMap.get("goodId");
    if (this.goodId === null) {
      return;
    }
    this.goodId = decodeURIComponent(this.goodId);
    this.goodsService.getGood(this.goodId).subscribe(data => {
      this.good = data;
    });
  }

  getRowSum(availableForDistribution: number, adjUnitPrice:number): string {
    return  MoneyUtil.toFixedTrunc(adjUnitPrice * availableForDistribution, 2);
  }

  pageChangeSpecifications(pageNumber: number) {
    this.selectedPageNumberSpecifications = pageNumber;
    this.loadData();
  }

  getFirstShowedRowIndexSpecifications(): number {
    return this.selectedPageNumberSpecifications === 1 ? 0 : (this.selectedPageNumberSpecifications - 1) * this.pageSizeSpecifications;
  }

  pageSizeChangedSpecifications(pageSize: number) {
    this.pageSizeSpecifications = pageSize;
    this.selectedPageNumberSpecifications = 1;
    this.loadData();
  }

  addFilterParams(params: HttpParams): HttpParams {

    if (this.good.mnnName) {
      params = params.append("conditions[0].fieldName", "goods_mnnName");
      params = params.append("conditions[0].value", this.good.mnnName);
      params = params.append("conditions[0].operator", "EQUALS");
    }

    // const subscriber = this.filter.suppliesSubject.subscribe(data => {
    //   let counter = 0;
    //   if (data.mnn.length) {
    //     params = params.append(`conditions[${counter}].fieldName`, "goods_mnnName");
    //     params = params.append(`conditions[${counter}].values`, data.mnn.join(", "));
    //     params = params.append(`conditions[${counter}].operator`, "IN");
    //     counter++;
    //   }
    //   if (data.status.length) {
    //     params = params.append(`conditions[${counter}].fieldName`, "status");
    //     params = params.append(`conditions[${counter}].values`, data.status.join(", "));
    //     params = params.append(`conditions[${counter}].operator`, "IN");
    //     counter++;
    //   }
    //   if (data.direction.length) {
    //     params = params.append(`conditions[${counter}].fieldName`, "goods_direction");
    //     params = params.append(`conditions[${counter}].values`, data.direction.join(", "));
    //     params = params.append(`conditions[${counter}].operator`, "IN");
    //     counter++;
    //   }
    //   if (data.subDirection.length) {
    //     params = params.append(`conditions[${counter}].fieldName`, "goods_subDirection");
    //     params = params.append(`conditions[${counter}].values`, data.subDirection.join(", "));
    //     params = params.append(`conditions[${counter}].operator`, "IN");
    //     counter++;
    //   }
    //   if (data.agreementNum.length) {
    //     params = params.append(`conditions[${counter}].fieldName`, "agreementNum");
    //     params = params.append(`conditions[${counter}].value`, data.agreementNum[0]);
    //     params = params.append(`conditions[${counter}].operator`, "CONTAINS");
    //     counter++;
    //   }
    //   if (data.supplier.length) {
    //     params = params.append(`conditions[${counter}].fieldName`, "supplierName");
    //     params = params.append(`conditions[${counter}].value`, data.supplier[0]);
    //     params = params.append(`conditions[${counter}].operator`, "CONTAINS");
    //     counter++;
    //   }
    //   if (data.actualDate.length) {
    //     const datepipe: DatePipe = new DatePipe("en-US");
    //     let formattedDate = datepipe.transform(new Date(data.actualDate[0]), "YYYY-MM-dd");
    //     params = params.append(`conditions[${counter}].fieldName`, "actualDeliveryDate");
    //     params = params.append(`conditions[${counter}].value`, formattedDate || "");
    //     params = params.append(`conditions[${counter}].operator`, "GREATER_THAN_EQUALS");
    //     counter++;
    //
    //     formattedDate = datepipe.transform(new Date(data.actualDate[1]), "YYYY-MM-dd");
    //     params = params.append(`conditions[${counter}].fieldName`, "actualDeliveryDate");
    //     params = params.append(`conditions[${counter}].value`, formattedDate || "");
    //     params = params.append(`conditions[${counter}].operator`, "LESS_THAN_EQUALS");
    //     counter++;
    //   }
    //
    //   if (data.expectedDate.length) {
    //     const datepipeExpected: DatePipe = new DatePipe("en-US");
    //     let formattedDate = datepipeExpected.transform(new Date(data.expectedDate[0]), "YYYY-MM-dd");
    //     params = params.append(`conditions[${counter}].fieldName`, "deliveryDate");
    //     params = params.append(`conditions[${counter}].value`, formattedDate || "");
    //     params = params.append(`conditions[${counter}].operator`, "GREATER_THAN_EQUALS");
    //     counter++;
    //
    //     formattedDate = datepipeExpected.transform(new Date(data.expectedDate[1]), "YYYY-MM-dd");
    //     params = params.append(`conditions[${counter}].fieldName`, "deliveryDate");
    //     params = params.append(`conditions[${counter}].value`, formattedDate || "");
    //     params = params.append(`conditions[${counter}].operator`, "LESS_THAN_EQUALS");
    //     counter++;
    //   }
    //
    //   if (data.warehouse.length) {
    //     params = params.append(`conditions[${counter}].fieldName`, "warehouseName");
    //     params = params.append(`conditions[${counter}].values`, data.warehouse.join(", "));
    //     params = params.append(`conditions[${counter}].operator`, "IN");
    //   }
    // });
    // subscriber.unsubscribe();
    return params;
  }

  // saveColumnOrder() {
  //   localStorage.setItem("suppiesColumnOrder", JSON.stringify(this.tabHeader));
  // }

  showHidedColumns($event: MouseEvent, columnKey: string, hide: boolean): void {
    $event.preventDefault();
    $event.stopPropagation();
    if (columnKey === "2") {
      this.hideGroup1 = hide;
    } else if (columnKey === "17") {
      this.hideGroup2 = hide;
    }
  }

  filterHeader(tabHeaderSpecifications: {
    label: string;
    key: string;
    date: boolean;
    filter: boolean;
    joinTable: string;
    showChevron: boolean;
    chevronOpen: boolean;
    hideAbleColumn: boolean;
  }[]) {
    let filtered = tabHeaderSpecifications;
    let headersForFilter: string[] = [];
    if (this.hideGroup1) {
      headersForFilter = ["3", "4", "5", "6", "7", "8", "9"];
    }
    if (this.hideGroup2) {
      headersForFilter = headersForFilter.concat(["18", "19", "20", "21"]);
    }

    if (headersForFilter.length > 0) {
      filtered = tabHeaderSpecifications.filter(value => !headersForFilter.includes(value.key));
    }

    return filtered;
  }

  goToGoods(supplyId: string): void {
    if (this.dataService.userRoleValue.getValue() === "DOZ") {
      void (0);
    } else {
      this.router.navigate(["/supplies/supply/" + encodeURIComponent(supplyId)], { relativeTo: this.route });
    }
  }

  loadData() {
    setTimeout(() => {
      this.getSpecifications(this.selectedPageNumberSpecifications);
    }, 1000);
  }

  getSpecifications(
    page: number | undefined,
  ): void {
    let params = new HttpParams();
    this.selectedPageNumberSpecifications = page ? page : 0;
    if (this.optionsModel !== 1) {
      params = params.append("warehouseName", this.optionsModel === 2 ? "Укрмедпостач" : "БЦФ");
    }

    params = this.appendFilterParams(params);

    params = params.append("page", this.selectedPageNumberSpecifications - 1);
    params = params.append("size", this.pageSizeSpecifications);
    // params = params.append("sort", sortFieldAndOrder);

    // this.loadingCounter++;
    // const timeoutId = setTimeout(() => {
    this.loadingCounter++;
    // }, 300);
    this.reserveController.retrieveDistributionGoodsSpec(params).subscribe(data => {
      this.tableBodySpecifications = data.content;
      this.totalRowsSpecifications = data.totalElements;
      if (this.loadingCounter === 0) {
        // clearTimeout(timeoutId)
      } else {
        this.loadingCounter--;
      }
    });

  }

  private appendFilterParams(params: HttpParams): HttpParams {
    if (this.good.mnnId) {
      params = params.append("conditions[0].fieldName", "goods_mnnId");
      params = params.append("conditions[0].value", this.good.mnnId);
      params = params.append("conditions[0].operator", "EQUALS");
    }
    return params;
  }

}
